var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('van-grid-item',{staticClass:"grid",class:{ disabled: _vm.isDisabled },attrs:{"icon":_vm.img,"text":_vm.title,"to":_vm.to,"badge":_vm.badge},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }